import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Injectable } from '@angular/core';
import { OAuthService } from 'angular-oauth2-oidc';
import { Observable, Observer } from 'rxjs';

@Injectable()
export class AuthGuard implements CanActivate {
    constructor(private authService: OAuthService) {
    }

    canActivate(
        route: ActivatedRouteSnapshot,
        state: RouterStateSnapshot): Observable<boolean> {
            return new Observable<boolean>((observer: Observer<boolean>) => {
                if (this.authService.hasValidAccessToken()) {
                    observer.next(true);
                } else {
                    this.authService.initLoginFlow(state.url);
                    observer.next(false);
                }
                observer.complete();
              });
    }
}
